import { AVAILABLE_MODES, useTheme, type Mode } from './useTheme';
import s from './ThemeSwitch.module.css';

// The theme control: three little icons — bulb (light), moon (dark), Game Boy
// (the DMG-green skin). One button per mode, the active one highlighted.

const Bulb = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 18h6M10 21h4" /><path d="M12 3a6 6 0 0 0-4 10.5c.6.6 1 1.3 1 2.1V16h6v-.4c0-.8.4-1.5 1-2.1A6 6 0 0 0 12 3z" />
  </svg>
);
const Moon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" /></svg>
);
const GameBoy = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round">
    <rect x="6" y="2.5" width="12" height="19" rx="2.2" />
    <rect x="8.3" y="5" width="7.4" height="6" rx="1" fill="currentColor" stroke="none" />
    <circle cx="9.4" cy="15" r="1.15" fill="currentColor" stroke="none" />
    <circle cx="14.6" cy="15" r="1.15" fill="currentColor" stroke="none" />
    <path d="M9 18.4h2M10 17.4v2" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

const ICON: Record<Mode, () => JSX.Element> = { light: Bulb, dark: Moon, gameboy: GameBoy };
const LABEL: Record<Mode, string> = { light: 'Light', dark: 'Dark', gameboy: 'Game Boy' };

export function ThemeSwitch() {
  const { mode, setMode } = useTheme();
  return (
    <div className={s.switch} role="group" aria-label="Theme">
      {AVAILABLE_MODES.map((m) => {
        const Icon = ICON[m];
        return (
          <button
            key={m}
            className={`${s.btn}${mode === m ? ' ' + s.on : ''}${m === 'gameboy' ? ' ' + s.gb : ''}`}
            onClick={() => setMode(m)}
            aria-label={LABEL[m]}
            aria-pressed={mode === m}
            title={LABEL[m]}
          >
            <Icon />
          </button>
        );
      })}
    </div>
  );
}
